import { Customer, Equipment, Order } from 'root/mibp-openapi-gen/models';
export interface IntegrationMessageTypeVm {
  identifier: string,
    title: string,
    messageName?: string;
    messageType: 'xml' | 'json';
    templateFilename?: string;
    exampleMessage?: string;
    description?: string;
}

export const resubmittableIntegrationMessageTypes: IntegrationMessageTypeVm[] = [
  {
    title: 'Product',
    identifier: 'product_create_item',
    messageName: 'CREATE_ITEM',
    messageType: 'xml',
    templateFilename: 'CREATE_ITEM_TEMPLATE.xml',
    description: 'Will save  message as blob in SMRT storage and send JSON message SMRT ServiceBus with blob filename'
  },
  {
    title: 'Global Product',
    identifier: 'product_create_item_mdg',
    messageName: 'CREATE_ITEM_MDG',
    messageType: 'xml',
    templateFilename: 'CREATE_ITEM_TEMPLATE.xml',
    description: 'Will save  message as blob in SMRT storage and send JSON message SMRT ServiceBus with blob filename'
  },
  {
    title: 'Order Acknowledgement',
    identifier: 'acknowledge_sales_order',
    messageName: 'acknowledge_sales_order',
    messageType: 'xml',
    description: 'Will save message as blob in SMRT storage and send JSON message SMRT ServiceBus with blob filename'
  },
  {
    title: 'Despatch Note',
    identifier: 'confirm_despatch',
    messageName: 'confirm_despatch',
    messageType: 'xml',
    description: ''
  },
  {
    title: 'Despatch Waybill',
    identifier: 'publish_waybill',
    messageName: 'publish_waybill',
    messageType: 'xml',
    description: ''
  },
  {
    title: 'Expected Delivery Date',
    identifier: 'publish_expected_delivery_date',
    messageName: 'publish_expected_delivery_date',
    messageType: 'xml',
    description: ''
  },
  {
    title: 'Invoice Address',
    identifier: 'publish_invoice_address',
    messageName: 'publish_invoice_address',
    messageType: 'xml',
    description: ''
  },

  {
    title: 'Customer',
    identifier: 'customer_notification',
    messageName: 'customer_notification',
    messageType: 'xml',
    // templateFilename: 'CustomerMaintainNotification_Template.xml',
  },
  {
    title: 'Equipment',
    identifier: 'equipment_new',
    messageName: 'equipment_new',
    messageType: 'xml',
    description: 'LDE only',
    templateFilename: 'EQUIPMENTNEW_Template.xml',
  },
  {
    title: 'StreamServe Invoice',
    identifier: 'streamserve_invoice',
    messageName: 'streamserve_invoice',
    messageType: 'json',
    exampleMessage: JSON.stringify({
      BlobName: 'Invoice_AU_123_ERP001.pdf',
      BlobPath: '/pdfdocument-streamserve/Invoice_AU_123_ERP001.pdf'
    }, null, 2),
    description: 'Load an example message or enter your own JSON. Select "Add fake PDF" to create a missing source blob before sending.'
  },
  {
    title: 'StreamServe Order',
    identifier: 'streamserve_order',
    messageName: 'streamserve_order',
    messageType: 'json',
    exampleMessage: JSON.stringify({
      BlobName: 'Order_AU_123_ERP001.pdf',
      BlobPath: '/pdfdocument-streamserve/Order_AU_123_ERP001.pdf'
    }, null, 2),
    description: 'Load an example message or enter your own JSON. Select "Add fake PDF" to create a missing source blob before sending.'
  },
  {
    title: 'StreamServe Quotation',
    identifier: 'streamserve_quotation',
    messageName: 'streamserve_quotation',
    messageType: 'json',
    exampleMessage: JSON.stringify({
      BlobName: 'Quotation_AU_123_ERP001.pdf',
      BlobPath: '/pdfdocument-streamserve/Quotation_AU_123_ERP001.pdf'
    }, null, 2),
    description: 'Load an example message or enter your own JSON. Select "Add fake PDF" to create a missing source blob before sending.'
  }
];
